module.exports = __webpack_public_path__ + "static/media/tracking4.ef1683f0.png";